import { Default } from "../../components/default/Default";

// The documentation lives on the marketing site (single source of truth) and is
// embedded here so the in-app docs are always identical to the public docs.
// ?embed=1 tells the docs site to hide its marketing nav/footer.
const DOCS_URL = "https://multicartapi.com/docs?embed=1";

export default function DocsEmbed() {
  return (
    <Default>
      <div style={{ height: "100vh", width: "100%", overflow: "hidden" }}>
        <iframe
          src={DOCS_URL}
          title="MultiCartAPI Documentation"
          style={{ width: "100%", height: "100%", border: 0, display: "block" }}
          allow="clipboard-write"
        />
      </div>
    </Default>
  );
}
